import React, { useState, useEffect } from "react";
import ArrowDown from "../../images/icons/ArrowDown.jsx";
import { useLanguage } from "../../contexts/LanguageContext";

export default function Button(props) {
  const { setGlobalLanguage, language } = useLanguage();

  const getInitialLanguage = () => language;

  const initialOption =
    props.variant === "outline" ? getInitialLanguage() : undefined;
  const [selectedOption, setSelectedOption] = useState(initialOption);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (props.variant === "outline") {
      setSelectedOption(getInitialLanguage());
    }
  }, [props.variant]);

  const handleOptionClick = (lang) => {
    setSelectedOption(lang);
    setGlobalLanguage(lang);
    setIsOpen(false);
  };

  const variantStyle =
    props.variant === "normal"
      ? "text-white bg-[#FD9790] px-8"
      : "text-[#FD9790] px-2 pr-5";

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className={`z-[100] ${props.className || ""}`}>
      <button
        className={`flex h-11 justify-center relative items-center text-base ${variantStyle} rounded-lg border border-[#FD9790] transition duration-500 hover:scale-105`}
        onClick={toggleDropdown}
      >
        {selectedOption || props.name}
        {props.variant === "outline" && (
          <ArrowDown className="absolute right-0.5 top-1/2 transform -translate-y-1/2" />
        )}
      </button>
      {isOpen && props.variant === "outline" && (
        <div className="absolute w-11 bg-white mt-1 rounded-lg shadow-lg z-[100]">
          <ul>
            {selectedOption !== "EN" && (
              <li
                className="flex h-11 w-11 justify-center relative cursor-pointer items-center rounded-lg border border-[#FD9790] text-base text-[#FD9790] transition duration-500 hover:scale-105 p-2 hover:bg-gray-100"
                onClick={() => handleOptionClick("EN")}
              >
                EN
              </li>
            )}
            {selectedOption !== "TR" && (
              <li
                className="flex h-11 w-11 justify-center relative cursor-pointer items-center text-base text-[#FD9790] rounded-lg border border-[#FD9790] transition duration-500 hover:scale-105 p-2 hover:bg-gray-100"
                onClick={() => handleOptionClick("TR")}
              >
                TR
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
